import { combineReducers } from 'redux'
import { ipAddressReducer } from '../reducers/IPAddressReducers/IPAddressReducer'
import { forgotPasswordReducer } from '../reducers/AuthReducers/forgotPasswordReducer'
import { loginReducer } from '../reducers/AuthReducers/loginReducer'
import { passwordResetReducer } from '../reducers/AuthReducers/passwordResetReducer'
import { logoutReducer } from '../reducers/AuthReducers/logoutReducer'
import { CtrlLocationReducers } from './SocietyController/CtrlLocationReducers/CtrlLocationReducers'
import { CtrlProfileReducers } from './SocietyController/CtrlProfileReducers/CtrlProfileReducers'
import { adminLoginReducer } from './AuthReducers/AdminLoginReducer/AdminLoginReducer'
import { InvoiceTypeReducers } from './SocietyPortal/InvoiceTypeReducers/InvoiceTypeReducers'
import { DocumentSeriesReducers } from './SocietyPortal/DocumentSeriesReducers/DocumentSeriesReducers'
import { SocietyProfileReducers } from './SocietyPortal/SocietyProfileReducers/SocietyProfileReducers'
import InvoiceSettingReducer from './SocietyPortal/InvoiceSettingReducer/InvoiceSettingReducer';
import TariffHeadReducer from './SocietyPortal/TariffHeadReducer/TariffHeadReducer';
import TaxRuleReducer from "./SocietyPortal/TaxRuleReducer/TaxRuleReducer";
import TariffRateReducer from './SocietyPortal/TariffRateReducer/TariffRateReducer';
import { SocietyReducers } from './SocietyPortal/SocietyReducers/SocietyReducers'
import { VendorReducers } from './SocietyPortal/VendorReducers/VendorReducers'
import WingsAndFlatsReducers from './WingsAndFlatsReducers/WingsAndFlatsReducers'
import { InvoiceReducer } from './SocietyPortal/InvoiceReducer/InvoiceReducer';
import { CtrlCommunityManagementReducers } from './SocietyController/CtrlCommunityManagementReducers/CtrlCommunityManagementReducers'
import { CtrlBrandReducers } from './SocietyController/CtrlBrandReducers/CtrlBrandReducers'
import { CtrlEmployeeReducer } from './SocietyController/CtrlEmployeeReducers/CtrlEmployeeReducer'
import { CtrlSystemRoleReducer } from './SocietyController/CtrlSystemRoleReducers/CtrlSystemRoleReducer'
import OccupantReducer from './SocietyPortal/OccupantReducer/OccupantReducer';
import MeterReadingReducer from './SocietyPortal/MeterReadingReducer/MeterReadingReducer';
import MeterSlabReducer from './SocietyPortal/MeterSlabReducer/MeterSlabReducer';
import { JournalReducer } from './SocietyPortal/JournalReducer/JournalReducer';
import OpeningBalanceReducer from './SocietyPortal/OpeningBalanceReducer/OpeningBalanceReducer';
import { CreditDebitNoteReducer } from './SocietyPortal/CreditDebitNoteReducer/CreditDebitNoteReducer';
import { ReceiptReducer } from './SocietyPortal/ReceiptReducer/ReceiptReducer';
import { AccountsOpeningReducer } from './SocietyPortal/AccountsOpeningReducer/AccountsOpeningReducer';
import { AccountsClosingReducer } from './SocietyPortal/AccountsClosingReducer/AccountsClosingReducer';
import { MemberDaybookReducer } from './SocietyPortal/MemberDaybookReducer/MemberDaybookReducer';
import { GLAccountReducer } from './SocietyPortal/GLAccountReducer/GLAccountReducer';
import { SocietyBankReducer } from './SocietyPortal/SocietyBankReducer/SocietyBankReducer';
import { FixedAssetReducer } from './SocietyPortal/FixedAssetReducer/FixedAssetReducer';
import { CashBankReducer } from './SocietyPortal/CashBankReducer/CashBankReducer';
import { InvestmentReducer } from './SocietyPortal/InvestmentReducer/InvestmentReducer';
import { BRSReducer } from './SocietyPortal/BRSReducer/BRSReducer';
import { AccountReportsReducer } from './SocietyPortal/AccountReportsReducer/AccountReportsReducer';
import { InvoiceReportReducer } from './SocietyPortal/InvoiceReportReducer/InvoiceReportReducer';
import { SocietyRoleReducer } from './SocietyPortal/RolePermissionReducer/SocietyRoleReducer';
import { UserSocietyReducer } from './SocietyPortal/RolePermissionReducer/UserSocietyReducer';
import accountLedgerReportReducer from './SocietyPortal/AccountLedgerReportReducer/AccountLedgerReportReducer';
import { DashboardReducer } from './SocietyPortal/DashboardReducer/DashboardReducer';
import { CtrlDashboardReducer } from './SocietyController/CtrlDashboardReducer/CtrlDashboardReducer';
import { EmployeeReducer } from './SocietyPortal/EmployeeReducer/EmployeeReducer';
import FlatTransferReducer from './SocietyPortal/FlatTransferReducer/FlatTransferReducer';
import ShareCertificateReducer from './SocietyPortal/ShareCertificateReducer/ShareCertificateReducer';
import { TaskReducer } from './SocietyPortal/TaskReducer/TaskReducer';
import { ComplaintReducer } from './SocietyPortal/ComplaintReducer/ComplaintReducer';
import { AttendanceReducer } from './SocietyPortal/AttendanceReducer/AttendanceReducer';
import { ShiftReducer } from './SocietyPortal/ShiftReducer/ShiftReducer';
import { NoticeReducer } from './SocietyPortal/NoticeReducer/NoticeReducer';
import { VisitorReducer } from './SocietyPortal/VisitorReducer/VisitorReducer';
import { VmsReducer } from './SocietyPortal/VmsReducer/VmsReducer';
import { MemberPortalReducer } from './SocietyPortal/MemberPortalReducer/MemberPortalReducer';


const rootReducer = combineReducers({
    ipAddressReducer,
    forgotPasswordReducer,
    loginReducer,
    passwordResetReducer,
    logoutReducer,
    adminLoginReducer,
    CtrlCommunityManagementReducers,
    CtrlBrandReducers,
    CtrlEmployeeReducer,
    CtrlSystemRoleReducer,
    CtrlLocationReducers,
    CtrlProfileReducers,
    InvoiceTypeReducers,
    DocumentSeriesReducers,
    SocietyProfileReducers,
    InvoiceSettingReducer,
    TariffHeadReducer,
    TaxRuleReducer,
    TariffRateReducer,
    SocietyReducers,
    VendorReducers,
    WingsAndFlatsReducers,
    InvoiceReducer,
    OccupantReducer,
    MeterReadingReducer,
    MeterSlabReducer,
    JournalReducer,
    OpeningBalanceReducer,
    CreditDebitNoteReducer,
    ReceiptReducer,
    AccountsOpeningReducer,
    AccountsClosingReducer,
    MemberDaybookReducer,
    GLAccountReducer,
    SocietyBankReducer,
    FixedAssetReducer,
    CashBankReducer,
    InvestmentReducer,
    BRSReducer,
    AccountReportsReducer,
    InvoiceReportReducer,
    SocietyRoleReducer,
    UserSocietyReducer,
    accountLedgerReportReducer,
    DashboardReducer,
    CtrlDashboardReducer,
    EmployeeReducer,
    FlatTransferReducer,
    ShareCertificateReducer,
    TaskReducer,
    ComplaintReducer,
    AttendanceReducer,
    ShiftReducer,
    NoticeReducer,
    VisitorReducer,
    VmsReducer,
    MemberPortalReducer,
})

export default rootReducer;
